<template>
  <div>
    <module-card :title="'补贴管理：' + info.activityName">
      <el-form :model="searchForm" :inline="true" label-width="85px" label-position="left">
        <el-form-item label="额度包周期">
          <date-range-picker :value="quotaPeriod" @getChange="value => quotaPeriod = value" :clearable="true" type="daterange" :maxRange="92" :afterLimit="false"></date-range-picker>
        </el-form-item>
        <el-form-item label="添加时间">
          <date-range-picker :value="inputTime" @getChange="value => inputTime = value" :clearable="true"></date-range-picker>
        </el-form-item>
        <el-form-item label="乐刷商户号">
          <el-input v-model="searchForm.merchantCode" placeholder="请输入商户号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入商户号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="绑卡状态" label-width="100px">
          <el-select placeholder="请选择绑卡状态" v-model="searchForm.status" clearable>
            <el-option
              v-for="item in bindStatusList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补贴状态" label-width="100px">
          <el-select placeholder="请选择补贴状态" v-model="searchForm.allowanceStatus" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值额度">
          <el-input type="number" v-model="searchForm.amount" placeholder="请输入已充值金额"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="searchForm.settleBankAccount" placeholder="请输入银行卡号" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户组编号">
          <el-input v-model="searchForm.subjectMerchant" placeholder="请输入商户组编号" clearable></el-input>
        </el-form-item>
        <div style="margin-bottom: 20px">
          <auth-button opt="search" :loading="searchLoading" @click.native="search" label="查询"></auth-button>
          <auth-button opt="export_basic" :loading="exportBasicLoading" @click.native="exportBasic" label="导出"></auth-button>
          <!-- <auth-button opt="export" :plain="true" label="导出商户【补贴明细】" :loading="exportLoading" @click.native="toExportQuota"></auth-button> -->
          <auth-button opt="quota_details_export" :plain="true" label="导出额度包补贴明细" :loading="exportLoading" @click.native="toExportQuotaDetails"></auth-button>
          <auth-button opt="quota_month_details_export" v-if="[20, 30].includes(info.activityType)" :plain="true" label="导出额度包补贴汇总" :loading="exportLoading" @click.native="toExportMonthQuotaDetails"></auth-button>
        </div>
        <div>
          <!-- <auth-button opt="merchant_info_export" :plain="true" label="导出【商户资料】" @click.native="toExportInfo"></auth-button> -->
          <!-- <auth-button opt="merchant_summary_export" :plain="true" label="导出【商户交易汇总】" @click.native="toExportSummery"></auth-button> -->
          <!-- <auth-button opt="merchant_details_export" :plain="true" label="导出【商户交易明细】" @click.native="toExportDetails"></auth-button> -->
        </div>
      </el-form>
    </module-card>

    <module-card title="商户管理">
      <auth-button opt="add" label="添加配置" icon="el-icon-plus" @click.native="toAddMerchant"></auth-button>
      <batch-import
        class="batchImport"
        submit-name="batchAddAllowanceMerchant"
        :limitNum="5000"
        buttonText="批量配置"
        templateName="批量配置商户模板"
        dialog-title="批量配置商户"
        @submit="importSubmit"
        failKey="failMerchants"
        opt="batch_add"
        :tableList="[
          { label: '商户编号', prop: 'merchantId' },
          { label: '本月额度包', prop: 'quota' },
          { label: '下月额度包', prop: 'nextQuota' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"
        :otherData="{
          activityId: info.activityId
        }"
        :needValid="true"
        validApi="batchAddVerify"
        :validTableList="[
          { label: '需配置商户  ', prop: 'needConfigMerchant' },
          { label: '已配置商户', prop: 'alreadyConfigMerchant' },
          { label: '结算卡号', prop: 'settleBankAccount' },
          { label: '已充值额度包金额', prop: 'quotaSum', ext: 'amount' }
        ]"></batch-import>
      <auth-button opt="shareGroup_add" label="创建共享额度包" @click.native="shareGroupAdd" style="margin-left: 10px"></auth-button>
      <auth-button opt="batch_append" label="批量追加/扣减额度包" @click.native="showBatchAddDialog = true"></auth-button>
      <el-table class="table" border :data="merchantList" v-loading="searchLoading">
        <el-table-column
          label="添加时间"
          prop="createTime"
          width="180">
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime"
          width="180">
        </el-table-column>
        <el-table-column
          label="乐刷商户号"
          prop="merchantCode"
          width="120">
        </el-table-column>
        <el-table-column
          label="商户简称"
          prop="merchantName"
          min-width="160">
        </el-table-column>
        <el-table-column
          label="银行卡号"
          prop="settleBankAccount"
          min-width="170">
        </el-table-column>
        <el-table-column
          label="绑卡状态"
          width="80"
          prop="status">
          <template slot-scope="scope">
            <span>{{getListText(scope.row.status, bindStatusList)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="代理商"
          prop="agentId"
          width="100">
        </el-table-column>
        <el-table-column
          label="已充值额度包"
          width="120"
          prop="quota">
        </el-table-column>
        <el-table-column
          label="额度包属性"
          width="120"
          prop="allowanceTypeStr">
        </el-table-column>
        <el-table-column
          label="商户组编号"
          width="150"
          prop="subjectMerchant">
        </el-table-column>
        <el-table-column
          label="额度包余额(元)"
          width="120"
          prop="remainQuota">
        </el-table-column>
        <el-table-column
          label="已清零额度包(元)"
          width="120"
          prop="cleanBalance">
        </el-table-column>
        <el-table-column
          label="额度包周期"
          width="200"
          prop="period">
        </el-table-column>
        <el-table-column
          label="补贴状态"
          width="80"
          prop="status">
          <template slot-scope="scope">
            <!-- <span>{{scope.row.status}}</span> -->
            <span :class="{'red': scope.row.allowanceStatus !== 1}">{{getStatus(scope.row.allowanceStatus)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="周期延用"
          width="120"
          prop="renewal">
          <template slot-scope="scope">
            <div>
              {{ scope.row.renewal === 1 ? '开启' : '关闭' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="最近操作人"
          width="120"
          prop="operator">
        </el-table-column>
        <el-table-column
          label="操作"
          width="400"
          fixed="right">
          <template slot-scope="scope">
            <div class="flex-space-between">
              <auth-button auth-type="span" opt="set" label="追加额度包" class="editBtn" @click.native="toEditQuota(scope.row)"></auth-button>
              <auth-button v-if="scope.row.allowanceStatus === 1" auth-type="span" opt="edit_status" label="不启用" class="editBtn" @click.native="changeStatus(scope.row)"></auth-button>
              <auth-button v-else auth-type="span" opt="edit_status" label="启用" class="editBtn" @click.native="changeStatus(scope.row)"></auth-button>
              <auth-button auth-type="span" opt="config_list" label="配置记录" class="editBtn" @click.native="quotaRecord(scope.row)"></auth-button>
              <auth-button auth-type="span" opt="quota_deduce" label="扣减额度包" class="editBtn" @click.native="toDeduceQuota(scope.row)"></auth-button>
              <auth-button auth-type="span" opt="shareGroup" label="共享额度包" class="editBtn" @click.native="ShareQuota(scope.row)" v-if="scope.row.allowanceType === 1"></auth-button>
              <auth-button auth-type="span" opt="shareGroup_add" label="创建共享额度包" class="editBtn" @click.native="createShareQuota(scope.row)" v-else></auth-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="searchForm.pageNo" :size="searchForm.pageSize" @changePage="value => { searchForm.pageNo = value;getMerchantList() }"></pagination>
    </module-card>

    <dialog-info title="添加配置" :visible.sync="showAddDialog" :confirmLoading="addLoading" @confirm="addMerchant">
      <el-form ref="addForm" :model="addForm" :rules="ruleData" label-position="left" label-width="100px" v-loading="addLoading">
        <el-form-item prop="merchantCode" label="商户号">
          <el-input v-model="addForm.merchantCode" placeholder="请输入商户号"></el-input>
        </el-form-item>
        <el-form-item prop="settleBankAccount" label="银行卡号">
          <el-input v-model="addForm.settleBankAccount" placeholder="请输入商户参与活动的银行卡号"></el-input>
        </el-form-item>
        <el-form-item prop="quota" label="本月额度包">
          <el-input v-model="addForm.quota" placeholder="请输入额度包金额" maxlength="7">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="nextQuota" label="下月额度包">
          <el-input v-model="addForm.nextQuota" placeholder="请输入额度包金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="是否开启补贴">
          <el-radio-group v-model="addForm.status">
            <el-radio :label="40">是</el-radio>
            <el-radio :label="10">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remarks" label="备注">
          <el-input class="remark" v-model="addForm.remarks" placeholder="请输入备注内容" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>

    <dialog-info title="追加额度包" :visible.sync="showQuotaDialog" :confirmLoading="setLoading" @confirm="setQuota">
      <el-form ref="quotaForm" :model="quotaForm" :rules="ruleData" label-position="left" label-width="110px">
        <!-- <el-form-item label="日期：">
          <span>{{quotaForm.depositDate}}</span>
        </el-form-item> -->
        <el-form-item prop="currentQuota" label="本月追加额度包">
          <el-input v-model="quotaForm.currentQuota" placeholder="请输入追加额度包金额" :disabled="timePassed">
            <template slot="append">元</template>
          </el-input>
          <span>额度包余额{{quotaForm.remainQuota}}元</span>
        </el-form-item>
        <el-form-item label="额度包属性">
          <span>
            {{ quotaForm.allowanceType === 1 ? '共享' : '独立' }}
          </span>
        </el-form-item>
        <el-form-item prop="nextQuota" label="下月额度包" style="margin-top: 10px">
          <el-input v-model="quotaForm.nextQuota" placeholder="请输入额度包金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <!-- <div class="tips">当天添加的商户，在当日24点前可修改本月额度包；<br>非当天添加的商户，不可修改本月额度包；</div> -->
        <el-form-item prop="auditEvidencePic" label="修改凭证" v-if="[1, 2].includes(this.$store.state.userInfo.roleId)" style="margin-top: 20px;">
          <upload-img-ele
            :required="false"
            ref="auditEvidencePic"
            :clearable="true"
            valueName="auditEvidencePic"
            :labelCenter="false"
            :value="quotaForm.auditEvidencePic"
            @upload="(data) => uploadSuccess(data, 'quotaForm')"></upload-img-ele>
        </el-form-item>
        <div class="tips">修改本月额度包 请上传凭证以供财务审核</div>
        <el-form-item prop="remarks" label="备注">
          <el-input class="remark" v-model="quotaForm.remarks" placeholder="请输入备注内容" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>

    <dialog-info :title="exportTitle" :visible.sync="showExportDialog" :confirmLoading="exportLoading" @confirm="exportTrade" confirmText="确定导出">
      <p class="timeTitle">选择交易时间</p>
      <date-range-picker :value="tradeTime" @getChange="getTradeTime" :clearable="true" :disabledAfter="disabledAfter" :maxRange="31" :disabledBefore="disabledBefore"></date-range-picker>
    </dialog-info>

    <dialog-info title="导出商户【补贴明细】" :visible.sync="showExportQuotaDialog" :confirmLoading="exportLoading" @confirm="exportQuota" confirmText="确定导出">
      <p class="timeTitle">选择交易时间</p>
      <date-range-picker type="month" format="" :value="exportMonth" @getChange="getExportMonth" :clearable="true"></date-range-picker>
    </dialog-info>

    <dialog-info title="导出额度包补贴汇总" :visible.sync="showExportMonthQuotaDialog" :confirmLoading="exportLoading" @confirm="exportMonthQuota" confirmText="确定导出">
      <p class="timeTitle">选择额度包周期</p>
      <date-range-picker type="month" format="" :value="exportMonth" @getChange="getExportMonth" :clearable="true" :disabledBefore="disabledBefore"></date-range-picker>
    </dialog-info>

    <dialog-info title="配置记录" :visible.sync="showConfigureDialog" :showCancelBtn="false" :showConfirmBtn="false" size="large">
      <el-table class="table" border :data="configureList" v-loading="configureLoading">
        <el-table-column
          label="配置时间"
          width="160"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="额度包金额"
          width="100"
          prop="quota">
        </el-table-column>
        <el-table-column
          label="额度包性质"
          width="100"
          prop="allowanceTypeStr">
        </el-table-column>
        <el-table-column
          label="额度包周期"
          width="100"
          prop="period">
        </el-table-column>
        <el-table-column
          label="操作人"
          width="100"
          prop="operator">
        </el-table-column>
        <el-table-column
          label="审核状态"
          width="100"
          prop="auditStatus">
          <template slot-scope="scope">
            {{getAuditStatus(scope.row.auditStatus)}}
          </template>
        </el-table-column>
        <el-table-column
          label="配置状态"
          width="100"
          prop="depositStatus">
          <template slot-scope="scope">
            {{getListText(scope.row.depositStatus, depositStatusList)}}
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remarks">
          <template slot-scope="scope">
            {{scope.row.remarks || '-'}}
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="quotaPagination.total" :page-no="quotaPagination.pageNo" :size="quotaPagination.pageSize" @changePage="value => { quotaPagination.pageNo = value;getConfigureList() }"></pagination>
    </dialog-info>

    <dialog-info title="扣减额度包" :visible.sync="showDeduceDialog" :confirmLoading="deduceLoading" @confirm="deduceQuota" @close="clearDeduce">
      <el-form ref="deduceForm" :model="deduceForm" :rules="deduceRule" label-position="left" label-width="100px">
        <el-form-item prop="quota" label="扣减金额">
          <el-input v-model="deduceForm.quota" placeholder="请输入额度包扣减金额">
            <template slot="append">元</template>
          </el-input>
          <span>额度包余额{{deduceForm.remainQuota}}元</span>
        </el-form-item>
        <el-form-item label="额度包属性">
          <span>
            {{ deduceForm.allowanceType === 1 ? '共享' : '独立' }}
          </span>
        </el-form-item>
        <el-form-item prop="auditEvidencePic" label="扣减凭证" style="margin-top: 20px;">
          <upload-img-ele
            :required="false"
            ref="auditEvidencePic"
            :clearable="true"
            valueName="auditEvidencePic"
            :labelCenter="false"
            :value="deduceForm.auditEvidencePic"
            @upload="(data) => uploadSuccess(data, 'deduceForm')"></upload-img-ele>
        </el-form-item>
        <div class="tips">扣减额度包，请上传凭证以供财务审核</div>
        <el-form-item prop="remarks" label="备注">
          <el-input class="remark" v-model="deduceForm.remarks" placeholder="请输入备注内容" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info title="配置提示" :visible.sync="showConfirmDialog" :confirmLoading="confirmLoading" @confirm="handleSetQuota" :dialogWidth="650" footerAlign="center">
      <div class="confirm-tips">请再次核实清楚商户的额度包</div>
      <el-table class="table" border :data="confirmList">
        <el-table-column
          label="已配置商户"
          prop="alreadyConfigMerchant">
        </el-table-column>
        <el-table-column
          label="结算卡号"
          width="300"
          prop="settleBankAccount">
        </el-table-column>
        <el-table-column
          label="已充值额度包金额"
          prop="quotaSum">
          <!-- <template slot-scope="scope"> -->
            <!-- {{(scope.row.quotaSum / 100).toFixed(2)}} -->
            <!-- {{scope.row.quotaSum}} -->
          <!-- </template> -->
        </el-table-column>
      </el-table>
    </dialog-info>

    <dialog-info
      :visible.sync="showCreateQuotaDialog"
      title="创建共享额度包商户组"
      footerAlign="center"
      @confirm="addShareGroup"
      @close="emptyShareGroupForm"
      :dialog-width="600"
      confirmText="创建共享额度包商户组"
      :showCancelBtn="false"
    >
      <div v-if="!isCreateQuoteFromColumn" style="margin: 15px 0;">
        <span style="margin-right: 10px;">商户组类型</span>
        <el-radio-group v-model="merchantGroupType">
          <el-radio :label="0">共享</el-radio>
          <el-radio :label="1">异卡共享</el-radio>
        </el-radio-group>
      </div>
      <template v-if="merchantGroupType === 0">
        <el-form ref="shareGroupForm" :model="shareGroupForm" :rules="ruleData" label-position="left" label-width="70px" style="margin-bottom: 10px">
          <el-form-item label="银行卡号">
            <el-input v-model="shareGroupForm.settleBankAccount" placeholder="请输入结算卡号" style="width: 45%; margin-right: 20px" :disabled="disBankAccount"></el-input>
            <el-button type="primary" @click="merchantCheck" :disabled="disBankAccount">查询结算卡号相同商户</el-button>
          </el-form-item>
          <span>银行卡号关联商户数量：{{ shareGroupForm.merchantNum ? shareGroupForm.merchantNum : 0 }}</span>
        </el-form>
        <span>关联银行卡现有共享额度包商户组：</span>
        <el-table class="table" border :data="shareGroupForm.merchantGroup" style="margin: 0 0 10px" :span-method="objectSpanMethod">
          <el-table-column
            label="商户组编号"
            prop="subjectMerchant">
          </el-table-column>
          <el-table-column
            label="商户号"
            prop="merchantId">
          </el-table-column>
          <el-table-column
            label="额度包金额（元）"
            prop="quota">
          </el-table-column>
        </el-table>

        <span>关联银行卡商户：</span>
        <el-table class="table" border :data="shareGroupForm.merchantList" style="margin: 0 0 30px">
          <el-table-column
            label="商户号"
            prop="merchantId"
            width="110">
          </el-table-column>
          <el-table-column
            label="额度包金额（元）"
            prop="quota"
            width="140">
          </el-table-column>
          <el-table-column
            label="是否配置下月额度包"
            prop="haveNextQuota">
            <template slot-scope="scope">
              {{ scope.row.haveNextQuota === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
            label="是否加入商户组"
            prop="status"
            width="120">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.status" @change="isjoinGroup(scope.row)" :label="1" :disabled="scope.row.haveNextQuota === 1">是</el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div style="margin: 15px 0;">
          <el-button type="primary" @click="createQuotaGroup">新建</el-button>
          <el-button type="primary" @click="addQuotaGroup">添加</el-button>
        </div>
        <el-table class="table" border :data="batchImportQuoteSuccessData" style="margin: 0 0 30px">
          <el-table-column
            label="商户组编号"
            prop="subjectMerchant">
          </el-table-column>
          <el-table-column
            label="商户数（个）"
            prop="merchantCount">
          </el-table-column>
          <el-table-column
            label="额度包金额（元）"
            prop="quota">
            <template slot-scope="{row}">
              <span>{{ row.quota }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-form ref="shareGroupForm" :model="shareGroupForm" :rules="ruleData" label-position="left" label-width="160px" v-loading="addLoading" style="margin-bottom: 10px">
        <el-form-item label="共享额度包金额（元）">
          <el-input ref="shareQuota" v-model="shareQuota" placeholder="" style="width: 218px" disabled></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>

    <dialog-info
      title=""
      :visible.sync="showCreateShareQuota"
      footerAlign="center"
      @confirm="quitShareGroup"
      @close="showCreateShareQuota = false; quitGroupForm = $options.data().quitGroupForm; groupType = '0'"
      :dialog-width="600"
      confirmText="退出额度包共享"
      :showConfirmBtn="groupType"
      :showCancelBtn="false"
    >
      <el-form ref="quitGroupForm" :model="quitGroupForm" :rules="ruleData" label-position="left" label-width="70px">
        <span>关联创建时间: {{ this.quitGroupForm.joinTime }}</span>
        <el-row type="flex" justify="center" align="middle">
          <el-col :span="4">
            <h3>关联商户</h3>
          </el-col>
          <el-col :span="20">
            <el-table class="table" border :data="quitGroupForm.merchantList" style="margin: 10px 0;" :span-method="objectSpanMethod2">
              <el-table-column
                label="商户编号"
                prop="merchantId">
              </el-table-column>
              <el-table-column
                label="商户名称"
                prop="merchantName">
              </el-table-column>
              <el-table-column
                label="共享额度包总额（元）"
                width="180px"
                prop="quota">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <p style="margin: 15px 0; color: #53baf6" v-show="!groupType">{{ this.quitGroupForm.outTime }}已取消共享额度包，将于{{ this.quitGroupForm.effectiveDate }}生效</p>
        <span style="color: #7f7f7f">备注：如商户取消额度包共享，修改配置后将在下个月生效。</span>
      </el-form>
    </dialog-info>

    <dialog-info title="" :visible.sync="showSuccessDialog" footerAlign="center" @confirm="createSuccess" @close="createSuccess" confirmText="知道了" :showCancelBtn="false" :dialog-width="350">
      <span>共享额度包商户组创建成功, 共享额度包金额为{{ this.shareQuota }}元。</span>
    </dialog-info>

    <dialog-info title="" :visible.sync="showQuitDialog" footerAlign="center" @confirm="confirmQuit" @close="showQuitDialog = false" confirmText="确认退出" :showCancelBtn="false" :dialog-width="350">
      <i class="el-icon-question"></i>
      <p>是否取消此商户共享额度包的关联？</p>
      <p>取消后商户独立使用额度包将在下月生效。</p>
    </dialog-info>

    <dialog-info
      :visible.sync="showBatchAddDialog"
      title="额度包批量追加/扣减"
      footerAlign="center"
      @confirm="batchAddQuota"
      @close="resetBatchAddForm"
      :confirmLoading="batchAddLoading"
      confirmText="确认"
      :showCancelBtn="false"
    >
      <el-form ref="BatchAddForm" :model="BatchAddForm" :rules="ruleData" label-position="left" style="margin-bottom: 10px">
        <el-form-item label="额度包批量配置类型" label-width="150px">
          <el-select v-model="BatchAddForm.rechargeType" placeholder="请选择额度包批量配置类型" style="width: 230px">
            <el-option label="追加额度包" value="1"></el-option>
            <el-option label="扣减额度包" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量导入" label-width="150px">
          <el-button  @click="getMultiFiles('file')" size="small" class="import">点击上传文件</el-button>
        </el-form-item>
        <el-col v-if="multiFileName !== ''" class="hasSelect" style="margin: 10px 0">
          <span>已选择: {{ multiFileName }}</span>
          <i class="el-icon-remove removeIcon" @click="removeFile"></i>
        </el-col>
        <a href="static/批量追加扣减额度包模板.xlsx" class="downloadLink">下载模板文件</a>
        <input type="file" ref="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        <p style="margin-top: 20px">备注：</p>
        <p>1.仅支持.xls、.xlsx格式</p>
        <p>2.导入须知：请下载批量配置模板，按照模板输入，每次导入不超过1000个</p>
      </el-form>
    </dialog-info>

    <dialog-info title="添加结果" :visible.sync="showResultDialog" @confirm="() => showResultDialog = false" confirmText="确定" size="middle" class="addResult">
      <p class="add-info">已成功添加{{successNum}}个商户，以下{{failNum}}个商户添加失败<span v-show="failNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
      <el-table class="table" border :data="failList">
        <el-table-column
          label="商户id"
          prop="merchantId">
        </el-table-column>
        <el-table-column
          label="额度"
          prop="quota">
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="errorMsg">
        </el-table-column>
      </el-table>
    </dialog-info>

    <!-- 新建/添加导入异卡共享额度包对话框 -->
    <dialog-info :title="quoteGroupDialogTitle" :visible.sync="showQuoteGroupDialog" @confirm="handleAddQuoteGroup" confirmText="确定" size="middle" class="addResult">
      <div class="import-tip">导入须知：请下载批量配置模板，按照模板输入，每次导入不超过5000个</div>
      <el-button type="primary" @click.native="getMultiFiles('merchantFile')" size="mini" class="import">批量导入</el-button>
      <a :href="'static/' + quoteGroupDialogFileName + '.xlsx'" class="downloadLink">下载模板文件</a>
      <input type="file" ref="merchantFile" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      <p>仅支持.xls、.xlsx格式</p>
      <el-col v-if="multiFileName !== ''" class="hasSelect">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
    </dialog-info>

    <dialog-info title="添加结果" :visible.sync="showQuoteGroupResultDialog" @confirm="() => showQuoteGroupResultDialog = false" confirmText="确定" size="middle" class="addResult">
      <p class="add-info">导入失败，以下{{ batchImportQuoteFailCount }}个商户添加失败</p>
      <el-table class="table" border :data="batchImportQuoteFailData">
        <el-table-column
          label="商户编号"
          prop="merchantId">
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="errorMsg">
        </el-table-column>
      </el-table>
    </dialog-info>

  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { downJumpConfirm, formateDate } from '@/assets/js/utils'
import batchImport from '@/components/upload/batchImport'
export default {
  name: 'quotaMerchant',
  components: {
    dateRangePicker: dateRangePicker,
    pagination: pagination,
    dialogInfo: dialogInfo,
    uploadImgEle: uploadImgEle,
    batchImport: batchImport
  },
  data () {
    return {
      disabledAfter: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`).getTime() - 1000,
      disabledBefore: new Date().setMonth(new Date().getMonth() - 12),
      searchLoading: false,
      info: {
        activityId: '',
        activityName: '',
        activityType: '',
        activityPeriod: ''
      },
      merchantList: [],
      searchForm: {
        merchantCode: '',
        agentId: '',
        settleName: '',
        allowanceStatus: '',
        pageNo: 1,
        pageSize: 10,
        createTimeStart: '',
        createTimeEnd: '',
        periodDateStart: '',
        periodDateEnd: '',
        status: '',
        amount: '',
        settleBankAccount: '',
        subjectMerchant: ''
      },
      inputTime: [],
      statusList: [{
        text: '开启',
        value: 1
      }, {
        text: '未开启',
        value: 0
      }],
      bindStatusList: [{
        text: '未预约',
        value: 10
      }, {
        text: '已指派',
        value: 50
      }, {
        text: '已预约',
        value: 20
      }, {
        text: '已开卡',
        value: 30
      }, {
        text: '已绑卡',
        value: 40
      }, {
        text: '无效',
        value: 0
      }],
      total: 1,
      exportTitle: '',
      showExportDialog: false,
      exportLoading: false,
      exportType: '', // 导出类型summery:交易汇总,details:交易明细
      tradeTime: [],
      tradeTimeStart: '',
      tradeTimeEnd: '',
      showAddDialog: false,
      addLoading: false,
      addForm: {
        merchantCode: '',
        quota: '',
        status: 40,
        nextQuota: '', // 下个月额度
        auditEvidencePic: '',
        remarks: '',
        settleBankAccount: ''
      },
      ruleData: {
        // 银行卡号
        settleBankAccount: [{
          validator: (rule, value, callback) => {
            if (value !== '' && !(/^\d+$/.test(value))) {
              callback(new Error('请输入正确的银行卡号'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        merchantCode: [{
          validator: (rule, value, callback) => {
            if (!value || !(/^\d+$/.test(value))) {
              callback(new Error('请输入正确的商户号'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        quota: [
          // { required: true, message: '请输入额度包金额', trigger: 'blur' },
          { pattern: /^(([1-9]{1}\d*)|([0]{1}))(\.(\d){0,2})?$/, message: '请输入额度包金额，最多两位小数', trigger: 'blur' }
        ],
        currentQuota: [{
          validator: (rule, value, callback) => {
            if (value && !(/^(([1-9]{1}\d*)|([0]{1}))(\.(\d){0,2})?$/.test(value))) {
              callback(new Error('请输入本月额度包金额，最多两位小数'))
            } else {
              callback()
            }
          },
          // required: true,
          trigger: 'blur'
        }],
        nextQuota: [{
          validator: (rule, value, callback) => {
            if (value !== '' && value !== null && !(/^(([1-9]{1}\d*)|([0]{1}))(\.(\d){0,2})?$/.test(value))) {
              callback(new Error('请输入下个月额度包金额，最多两位小数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        auditEvidencePic: [{
          validator: (rule, value, callback) => {
            if (this.quotaType === 'edit' && !value && this.quota !== this.quotaForm.currentQuota && this.$store.state.userInfo.roleId === 1) {
              callback(new Error('本月额度包金额修改请上传修改凭证'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      quotaForm: {
        merchantId: '',
        createTime: '',
        currentTime: '',
        currentQuota: '', // 本月额度
        remainQuota: '', // 本月剩余
        nextQuota: '', // 下个月额度
        auditEvidencePic: '',
        remarks: '',
        allowanceType: '' // 额度包属性
      },
      quota: '',
      setLoading: false,
      showExportQuotaDialog: false,
      exportMonth: '',
      showQuotaDialog: false,
      showExportMonthQuotaDialog: false,
      quotaType: 'add',
      quotaPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      showConfigureDialog: false,
      configureLoading: false,
      quotaMerchantId: '',
      configureList: [],
      auditList: [
        {
          label: '待审核',
          value: 0
        }, {
          label: '审核成功',
          value: 1
        }, {
          label: '审核失败',
          value: 2
        }, {
          label: '存量已充值',
          value: 3
        }, {
          label: '无需审核',
          value: 4
        }, {
          label: '已撤销',
          value: 5
        }
      ],
      showBatchResultDialog: false,
      quotaPeriod: [],
      depositStatusList: [
        {
          text: '-',
          value: 0
        }, {
          text: '已充值',
          value: 1
        }, {
          text: '未充值',
          value: 2
        }, {
          text: '已扣减',
          value: 3
        }, {
          text: '未扣减',
          value: 4
        }, {
          text: '扣减失败',
          value: 5
        }, {
          text: '充值失败',
          value: 6
        }
      ],
      showDeduceDialog: false,
      deduceLoading: false,
      deduceForm: {
        quota: '',
        auditEvidencePic: '',
        merchantId: '',
        remainQuota: '',
        remarks: '',
        allowanceType: ''
      },
      deduceRule: {
        quota: [
          { required: true, message: '请输入额度包金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              console.log(value)
              if (!value || !(/^(([1-9]{1}\d*)|([0]{1}))(\.(\d){0,2})?$/.test(value))) {
                callback(new Error('请输入额度包扣减金额，最多两位小数'))
              } else if (Number(value) > this.deduceForm.remainQuota) {
                callback(new Error('扣减金额不能超过额度包余额'))
              } else {
                callback()
              }
            },
            required: true,
            trigger: 'blur'
          }]
      },
      exportBasicLoading: false,
      showConfirmDialog: false,
      confirmLoading: false,
      confirmList: [],
      checkType: 'simple', // simple batch
      showCreateQuotaDialog: false,
      showCreateShareQuota: false,
      showSuccessDialog: false,
      showQuitDialog: false,
      shareGroupForm: {
        settleBankAccount: '',
        merchantNum: ''
      },
      merchantGroupType: 0, // 商户组类型 0：同卡，1：异卡
      isCreateQuoteFromColumn: true, // 创建共享额度包是否来自于操作栏
      showQuoteGroupDialog: false,
      quoteGroupDialogType: '', // 新建/添加异卡共享商户组
      showQuoteGroupResultDialog: false, // 导入异卡共享商户组失败结果
      batchImportQuoteSuccessData: [],
      batchImportQuoteFailData: [],
      batchImportQuoteFailCount: '',
      quitGroupForm: {},
      shareQuota: '0',
      groupType: '0', // 是否加入商户组
      createShareGroup: {
        subjectMerchant: '',
        encSettleBankAccount: '',
        merchantIdList: []
      },
      disBankAccount: false,
      showResultDialog: false,
      showBatchAddDialog: false,
      BatchAddForm: {
        rechargeType: '1'
      },
      multiFileName: '',
      multiFile: '',
      successNum: '',
      failNum: '',
      failList: [],
      failMerchants: [],
      batchAddLoading: false
    }
  },
  computed: {
    timePassed () {
      if (this.quotaForm.createTime && this.quotaForm.currentTime) {
        const today = this.quotaForm.currentTime.substr(0, 10)
        return today !== this.quotaForm.createTime.substr(0, 10) && ![1, 2, 10].includes(this.$store.state.userInfo.roleId)
      } else {
        return true
      }
    },
    quoteGroupDialogTitle () {
      return this.quoteGroupDialogType === 'create' ? '新建异卡共享额度包商户组' : '添加异卡共享商户组商户'
    },
    quoteGroupDialogFileName () {
      return this.quoteGroupDialogType === 'create' ? '新建商户组模板' : '添加商户组模板'
    }
  },
  mounted () {
    this.searchForm.merchantCode = this.$route.params.merchantCode
    this.searchForm.agentId = this.$route.params.agentId
    this.info.activityId = this.$route.query.id
    this.info.activityName = this.$route.query.name
    this.info.activityType = parseInt(this.$route.query.type)
    this.info.activityPeriod = this.$route.query.period
    if (!this.hasData(this.$route.query)) {
      this.info = JSON.parse(localStorage.getItem('quotaInfo'))
    } else {
      localStorage.setItem('quotaInfo', JSON.stringify(this.info))
    }
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth()
    const thisMonth = new Date().getDate() >= parseInt(this.info.activityPeriod) ? 0 : 1
    const endDate = formateDate(new Date(currentYear, currentMonth + 1 - thisMonth, this.info.activityPeriod - 1)).substring(0, 10)
    const startDate = formateDate(new Date(currentYear, currentMonth - thisMonth, this.info.activityPeriod)).substring(0, 10)
    this.quotaPeriod = [startDate, endDate]
    this.init()
  },
  activated () {
    if (!this.hasData(this.$route.query)) {
      if (!this.hasData(this.info)) {
        this.info = JSON.stringify(localStorage.getItem('quotaInfo'))
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()
        const thisMonth = new Date().getDate() >= parseInt(this.info.activityPeriod) ? 0 : 1
        const endDate = formateDate(new Date(currentYear, currentMonth + 1 - thisMonth, this.info.activityPeriod - 1)).substring(0, 10)
        const startDate = formateDate(new Date(currentYear, currentMonth - thisMonth, this.info.activityPeriod)).substring(0, 10)
        this.quotaPeriod = [startDate, endDate]
        this.searchForm.merchantCode = this.$route.params.merchantCode
        this.searchForm.agentId = this.$route.params.agentId
        this.init()
      }
    } else {
      if (this.info.activityId !== this.$route.query.id || this.info.activityName !== this.$route.query.name || this.info.activityType !== parseInt(this.$route.query.type)) {
        this.info.activityId = this.$route.query.id
        this.info.activityName = this.$route.query.name
        this.info.activityType = parseInt(this.$route.query.type)
        this.info.activityPeriod = this.$route.query.period
        localStorage.setItem('quotaInfo', JSON.stringify(this.info))
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()
        const thisMonth = new Date().getDate() >= parseInt(this.info.activityPeriod) ? 0 : 1
        const endDate = formateDate(new Date(currentYear, currentMonth + 1 - thisMonth, this.info.activityPeriod - 1)).substring(0, 10)
        const startDate = formateDate(new Date(currentYear, currentMonth - thisMonth, this.info.activityPeriod)).substring(0, 10)
        this.quotaPeriod = [startDate, endDate]
        this.searchForm.merchantCode = this.$route.params.merchantCode
        this.searchForm.agentId = this.$route.params.agentId
        this.init()
      }
    }
    if (this.searchForm.merchantCode !== this.$route.params.merchantCode || this.searchForm.agentId !== this.$route.params.agentId) {
      this.searchForm.merchantCode = this.$route.params.merchantCode
      this.searchForm.agentId = this.$route.params.agentId
      this.init()
    }
  },
  methods: {
    async init () {
      await this.getMerchantList()
    },
    getMerchantList () {
      this.searchForm.createTimeStart = this.inputTime[0]
      this.searchForm.createTimeEnd = this.inputTime[1]
      this.searchForm.periodDateStart = this.quotaPeriod[0]
      this.searchForm.periodDateEnd = this.quotaPeriod[1]
      if (!this.quotaPeriod || !this.quotaPeriod[0] || !this.quotaPeriod[1]) {
        this.$message({
          type: 'warning',
          message: '请选择额度包周期进行查询',
          showClose: true
        })
        return
      }
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId
      })
      this.searchLoading = true
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$api.allowanceMerchantList, params).then(res => {
          this.searchLoading = false
          if (res.respCode === '0') {
            this.merchantList = res.data.list
            this.total = res.data.count
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    search () {
      this.searchForm.pageNo = 1
      this.getMerchantList()
    },
    /**
     * @description 点击添加额度包商户
     */
    toAddMerchant () {
      this.addForm = this.$options.data().addForm
      this.showAddDialog = true
      this.quotaType = 'add'
      const that = this
      setTimeout(function () {
        that.$refs.addForm.clearValidate()
      }, 100)
    },
    /**
     * @description 添加额度包商户
     */
    addMerchant () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('是否确认提交？', '温馨提醒').then(() => {
            this.checkValid()
          }).catch(() => {
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    /**
     * @description 点击配置额度包
     */
    toEditQuota (row) {
      this.$axios.post(this.$api.quotaRemain, {
        merchantId: row.id
      }).then(res => {
        if (res.respCode === '0') {
          this.quotaForm = res.data
          this.quotaForm.auditEvidencePic = res.data.auditEvidencePic
          // this.quotaForm.remainQuota = row.remainQuota
          this.quotaForm.merchantId = row.id
          this.quotaForm.merchantCode = row.merchantCode
          this.quotaForm.createTime = row.createTime
          this.quotaForm.currentQuota = ''
          this.quotaForm.auditEvidencePic = ''
          this.quota = res.data.currentQuota
          this.quotaType = 'edit'
          this.showQuotaDialog = true
        }
      }).catch(e => {
        this.$message({
          type: 'error',
          message: '加载失败！'
        })
      })
    },
    /**
     * @description 提交配置额度包接口
     */
    setQuota () {
      if (this.setLoading) {
        return
      }
      if (!this.quotaForm.currentQuota && !this.quotaForm.nextQuota) {
        this.$message({
          type: 'warning',
          message: '请至少配置本月/下月额度包额度包中一个'
        })
        return
      }
      this.setLoading = true
      this.$refs.quotaForm.validate((valid) => {
        if (valid) {
          this.checkValid()
        } else {
          this.setLoading = false
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    /**
     * @description 编辑商户状态，停止或开启补贴
     */
    changeStatus (row) {
      const title = row.allowanceStatus === 1 ? '停止' : '开启'
      const status = row.allowanceStatus === 1 ? 0 : 1
      const that = this
      this.$confirm('是否确认' + title + '商户补贴?', '温馨提醒').then(() => {
        that.$axios.post(that.$api.changeStatus, {
          merchantId: row.id,
          status: status
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              message: '修改状态成功！'
            })
            that.getMerchantList()
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '修改状态失败！'
          })
        })
      }).catch(() => {
      })
    },
    /**
     * @description 导出已绑卡【商户资料】
     */
    toExportInfo () {
      this.searchForm.createTimeStart = this.inputTime[0]
      this.searchForm.createTimeEnd = this.inputTime[1]
      this.searchForm.periodDateStart = this.quotaPeriod[0]
      this.searchForm.periodDateEnd = this.quotaPeriod[1]
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        month: this.exportMonth
      })
      const that = this
      this.$confirm('确定导出 【已绑卡】的商户资料?', '温馨提醒', {
        confirmButtonText: '确定导出'
      }).then(() => {
        // 确定导出
        that.$axios.post(that.$api.exportInfo, params).then(res => {
          if (res.respCode === '0') {
            downJumpConfirm.call(that)
          }
        })
      }).catch(() => {
      })
    },
    /**
     * @description 点击导出已绑卡商户【交易汇总】按钮
     */
    toExportSummery () {
      this.exportTitle = '导出已绑卡商户【交易汇总】'
      this.exportType = 'summery'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    /**
     * @description 点击导出已绑卡商户【交易明细】按钮
     */
    toExportDetails () {
      this.exportTitle = '导出已绑卡商户【交易明细】'
      this.exportType = 'details'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    /**
     * @description 点击导出补贴明细按钮
     */
    toExportQuota () {
      this.exportMonth = ''
      this.showExportQuotaDialog = true
    },
    /**
     * @description 导出交易起止时间
     * @params {Array} value 选中时间数组
     */
    getTradeTime (value) {
      if (value != null) {
        this.tradeTimeStart = value[0]
        // this.tradeTimeEnd = value[1].substr(0, 10) + ' 23:59:59'
        this.tradeTimeEnd = value[1]
        this.tradeTime = [this.tradeTimeStart, this.tradeTimeEnd]
      } else {
        this.tradeTimeStart = ''
        this.tradeTimeEnd = ''
        this.tradeTime = []
      }
    },
    /**
     * @description 导出补贴明细
     */
    exportQuota () {
      if (this.exportLoading) {
        return
      }
      this.exportLoading = true
      this.searchForm.createTimeStart = this.inputTime[0]
      this.searchForm.createTimeEnd = this.inputTime[1]
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        month: this.exportMonth
      })
      this.$axios.post(this.$api.exportMerchant, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
        this.showExportQuotaDialog = false
      })
    },
    /**
     * @description 导出已绑卡商户【交易明细】或者 【交易汇总】
     */
    exportTrade () {
      if (this.tradeTimeStart === '' || this.tradeTimeEnd === '') {
        this.$message({
          type: 'warning',
          message: '请选择完整导出时间！'
        })
        return
      }
      if (this.exportLoading) {
        return
      }
      // 根据exportType导出不同数据
      this.exportLoading = true
      let api
      switch (this.exportType) {
        case 'detail': {
          api = 'exportTradeDetail'
          break
        }
        case 'summery': {
          api = 'exportTradeSummary'
          break
        }
        case 'quotaDetails': {
          api = 'exportAllowance'
        }
      }
      this.searchForm.createTimeStart = this.inputTime[0]
      this.searchForm.createTimeEnd = this.inputTime[1]
      const params = Object.assign({}, {
        tradeTimeStart: this.tradeTimeStart,
        tradeTimeEnd: this.tradeTimeEnd,
        activityId: this.info.activityId,
        merchantId: this.searchForm.merchantCode
      }, this.searchForm)
      this.$axios.post(this.$api[api], params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
        this.tradeTimeStart = ''
        this.tradeTimeEnd = ''
        this.tradeTime = []
        this.showExportDialog = false
      }).catch(e => {
        this.exportLoading = false
      })
    },
    getExportMonth (val) {
      console.log(val)
      // this.exportMonth = val ? formateDate(new Date(val)) : ''
      if (val.length) {
        this.exportMonth = val ? val.substr(0, 7) : ''
      }
    },
    toExportQuotaDetails () {
      this.exportTitle = '导出额度包补贴明细'
      this.exportType = 'quotaDetails'
      this.tradeTime = []
      this.tradeTimeStart = ''
      this.tradeTimeEnd = ''
      this.showExportDialog = true
    },
    getStatus (status) {
      return status === 1 ? '开启' : '未开启'
    },
    toExportMonthQuotaDetails () {
      this.exportMonth = ''
      this.showExportMonthQuotaDialog = true
    },
    exportMonthQuota () {
      if (!this.exportMonth) {
        this.$message({
          type: 'warning',
          message: '请选择额度包周期进行导出',
          showClose: true
        })
        return
      }
      if (this.exportLoading) {
        return
      }
      this.exportLoading = true
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId,
        month: this.exportMonth,
        merchantId: this.searchForm.merchantCode
      })
      this.exportLoading = false
      this.$axios.post(this.$api.exportMonthQuota, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
        this.showExportMonthQuotaDialog = false
      })
    },
    getListText (status, list) {
      const result = list.filter(item => {
        return item.value === status
      })
      if (result.length === 0) {
        return '未知'
      } else {
        return result[0].text
      }
    },
    // 获取上传的图片
    uploadSuccess (data, form) {
      if (data.path) {
        this[form][data.valueName] = data.path
      } else {
        this[form][data.valueName] = ''
      }
    },
    getConfigureList () {
      const params = Object.assign({}, this.quotaPagination, {
        merchantId: this.quotaMerchantId,
        activityId: this.info.activityId
      })
      this.configureLoading = true
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$api.quotaPages, params).then(res => {
          this.configureLoading = false
          if (res.respCode === '0') {
            this.configureList = res.data.list
            this.quotaPagination.total = res.data.count
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    quotaRecord (row) {
      this.quotaMerchantId = row.id
      this.quotaPagination.pageNo = 1
      this.getConfigureList()
      this.showConfigureDialog = true
    },
    getAuditStatus (key) {
      const result = this.auditList.filter(item => item.value === key)
      if (result.length > 0) {
        return result[0].label
      } else {
        return '-'
      }
    },
    hasData (obj) {
      let hasResult = true
      let total = 0
      // for (const key in obj) {
      //   total += 1
      //   if (obj[key] === undefined || obj[key] === '') {
      //     hasResult = false
      //   }
      // }
      // 解决sonar问题：for in循环会遍历原型链上的属性
      Object.keys(obj).forEach(key => {
        total += 1
        if (obj[key] === undefined || obj[key] === '') {
          hasResult = false
        }
      })
      return total && hasResult
    },
    jumpDownload () {
      this.showBatchResultDialog = false
      this.$store.dispatch('delVisitedViews', {
        path: '/fileManage/downloadCenter'
      }).then(() => {
        this.$router.push('/fileManage/downloadCenter')
      })
    },
    /**
     * @description 点击扣减额度包
     */
    toDeduceQuota (row) {
      this.$axios.post(this.$api.quotaRemain, {
        merchantId: row.id
      }).then(res => {
        if (res.respCode === '0') {
          this.deduceForm.remainQuota = res.data.remainQuota
          this.deduceForm.allowanceType = res.data.allowanceType
          this.deduceForm.merchantId = row.id
          this.showDeduceDialog = true
        }
      }).catch(e => {
        this.$message({
          type: 'error',
          message: '加载失败！'
        })
      })
    },
    deduceQuota () {
      console.log(this.$refs.deduceForm)
      this.$refs.deduceForm.validate(valid => {
        console.log(valid)
        if (valid) {
          this.deduceLoading = true
          const params = Object.assign({}, {
            merchantId: this.deduceForm.merchantId,
            quota: this.deduceForm.quota,
            auditEvidencePic: this.deduceForm.auditEvidencePic,
            remarks: this.deduceForm.remarks
          })
          this.$axios.post(this.$api.deduceQuota, params).then(res => {
            this.deduceLoading = false
            if (res.respCode === '0') {
              this.$message({
                type: 'success',
                message: '扣减成功！'
              })
              this.showDeduceDialog = false
              this.getMerchantList()
            }
          })
        }
      })
    },
    clearDeduce () {
      this.deduceForm = this.$options.data().deduceForm
      this.$refs.deduceForm.clearValidate()
    },
    exportBasic () {
      this.searchForm.createTimeStart = this.inputTime[0]
      this.searchForm.createTimeEnd = this.inputTime[1]
      this.searchForm.periodDateStart = this.quotaPeriod[0]
      this.searchForm.periodDateEnd = this.quotaPeriod[1]
      if (!this.quotaPeriod || !this.quotaPeriod[0] || !this.quotaPeriod[1]) {
        this.$message({
          type: 'warning',
          message: '请选择额度包周期进行导出',
          showClose: true
        })
        return
      }
      const params = Object.assign({}, this.searchForm, {
        activityId: this.info.activityId
      })
      this.exportBasicLoading = true
      this.$axios.post(this.$api.exportQuotaBasic, params).then(res => {
        this.exportBasicLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    importSubmit (result) {
      if (result) {
        this.getMerchantList()
      }
    },
    handleSetQuota () {
      this.showConfirmDialog = false
      if (this.quotaType === 'add') {
        this.addLoading = true
        const params = Object.assign({}, this.addForm, {
          activityId: this.info.activityId
        })
        this.$axios.post(this.$api.addAllowanceMerchant, params).then(res => {
          this.addLoading = false
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              message: '新增成功！'
            })
            this.showAddDialog = false
            this.showConfirmDialog = false
            this.search()
          }
        })
      } else {
        this.setLoading = true
        const params = Object.assign({}, this.quotaForm, {
          currentQuota: this.quotaForm.currentQuota ? parseFloat(this.quotaForm.currentQuota * 100) / 100 : '',
          nextQuota: this.quotaForm.nextQuota ? parseFloat(this.quotaForm.nextQuota * 100) / 100 : ''
        })
        this.$axios.post(this.$api.setQuota, params).then(res => {
          this.setLoading = false
          if (res.respCode === '0') {
            this.showQuotaDialog = false
            this.showConfirmDialog = false
            this.$message({
              type: 'success',
              message: '配置成功！'
            })
            this.search()
          }
        })
      }
    },
    checkValid () {
      const params = {
        merchantCode: this.quotaType === 'add' ? this.addForm.merchantCode : this.quotaForm.merchantCode,
        quota: this.quotaType === 'add' ? this.addForm.quota : this.quotaForm.currentQuota,
        nextQuota: this.quotaType === 'add' ? this.addForm.nextQuota : this.quotaForm.nextQuota,
        settleBankAccount: this.addForm.settleBankAccount,
        activityId: this.info.activityId,
        status: 40
      }
      this.addLoading = true
      this.setLoading = true
      this.$axios.post(this.$api.addVerify, params).then(res => {
        this.addLoading = false
        this.setLoading = false
        if (res.respCode === '0') {
          if (res.data.length === 0) {
            this.handleSetQuota()
          } else {
            this.confirmList = res.data
            this.showConfirmDialog = true
          }
        }
      })
    },
    // 共享额度包
    ShareQuota (row) {
      const params = {
        activityId: this.info.activityId,
        merchantId: row.merchantCode
      }
      this.$axios.post(this.$api.shareGroupQuota, params).then(res => {
        if (res.respCode === '0') {
          this.showCreateShareQuota = true
          this.groupType = res.data.groupType
          this.quitGroupForm = res.data
        }
      })
    },
    // 创建共享额度包弹窗
    createShareQuota (row) {
      this.isCreateQuoteFromColumn = true
      const params = {
        activityId: this.info.activityId,
        merchantId: row.merchantCode
      }
      this.$axios.post(this.$api.merchantCheck, params).then(res => {
        if (res.respCode === '0') {
          this.disBankAccount = true
          this.shareGroupForm = res.data
          this.createShareGroup.encSettleBankAccount = res.data.encSettleBankAccount
          if (res.data.merchantGroup) {
            const obj = res.data.merchantGroup.find(value => value.subjectMerchant)
            this.createShareGroup.subjectMerchant = obj.subjectMerchant
          }
          if (res.data.merchantGroup) {
            const obj = res.data.merchantGroup.find(value => value.quota)
            this.shareQuota = Number(obj.quota)
          }
          this.showCreateQuotaDialog = true
        }
      })
    },
    // 查询结算卡号相同商户
    merchantCheck () {
      const params = {
        activityId: this.info.activityId,
        settleBankAccount: this.shareGroupForm.settleBankAccount
      }
      this.$axios.post(this.$api.merchantCheck, params).then(res => {
        if (res.respCode === '0') {
          this.disBankAccount = true
          this.shareGroupForm.merchantGroup = res.data.merchantGroup
          this.shareGroupForm.merchantList = res.data.merchantList
          this.shareGroupForm.merchantNum = res.data.merchantNum
          this.createShareGroup.encSettleBankAccount = res.data.encSettleBankAccount
          if (res.data.merchantGroup) {
            const obj = res.data.merchantGroup.find(value => value.subjectMerchant)
            this.createShareGroup.subjectMerchant = obj.subjectMerchant
          }
          if (res.data.merchantGroup) {
            const obj = res.data.merchantGroup.find(value => value.quota)
            this.shareQuota = Number(obj.quota)
          }
        }
      })
    },
    // 退出额度包共享弹窗
    quitShareGroup () {
      // this.showCreateShareQuota = false
      // setTimeout(() => {
      //   this.showQuitDialog = true
      // }, 250)
      this.showQuitDialog = true
    },
    // 确认退出共享额度包
    confirmQuit () {
      const params = {
        activityId: this.info.activityId,
        merchantId: this.quitGroupForm.merchantId
      }
      this.$axios.post(this.$api.shareGroupOut, params).then(res => {
        if (res.respCode === '0') {
          this.showQuitDialog = false
          this.$axios.post(this.$api.shareGroupQuota, params).then(res => {
            if (res.respCode === '0') {
              this.groupType = res.data.groupType
              this.quitGroupForm = res.data
            }
          })
        }
      })
    },
    // 创建共享额度包弹窗
    shareGroupAdd () {
      this.showCreateQuotaDialog = true
      this.isCreateQuoteFromColumn = false
    },
    // 创建共享额度包商户组
    addShareGroup () {
      const params = {
        activityId: this.info.activityId
      }
      if (this.merchantGroupType === 0) {
        // 添加同卡共享
        this.$axios.post(this.$api.shareGroupAdd, { ...params, ...this.createShareGroup }).then(res => {
          if (res.respCode === '0') {
            this.showSuccessDialog = true
          }
        })
      } else {
        // 添加异卡共享
        if (!this.batchImportQuoteSuccessData.length) {
          return this.$message({
            message: '不符合条件',
            type: 'warning'
          })
        }
        let apiKey = 'batchCreateQuote'
        if (this.quoteGroupDialogType === 'add') {
          apiKey = 'batchAddQuote'
        }
        const importParams = this.handleBatchAddQuoteGroupImport()
        importParams.append('subjectMerchant', this.batchImportQuoteSuccessData[0].subjectMerchant)
        this.$axios.post(this.$api[apiKey], importParams).then(res => {
          if (res.respCode === '0') {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.createSuccess()
          }
        })
      }
    },
    // 是否加入商户组
    isjoinGroup (row) {
      if (row.status) {
        this.shareQuota = Number(this.shareQuota) + Number(row.quota)
        this.createShareGroup.merchantIdList.push(row.merchantId)
      } else {
        this.shareQuota = Number(this.shareQuota) - Number(row.quota)
        this.createShareGroup.merchantIdList = this.createShareGroup.merchantIdList.filter(item => item !== row.merchantId)
      }
    },
    // 创建成功
    createSuccess () {
      this.showSuccessDialog = false
      setTimeout(() => {
        this.showCreateQuotaDialog = false
        this.getMerchantList()
      }, 250)
    },
    // 退出弹窗初始化
    emptyShareGroupForm () {
      this.showCreateQuotaDialog = false
      this.disBankAccount = false
      this.shareGroupForm = this.$options.data().shareGroupForm
      this.createShareGroup = this.$options.data().createShareGroup
      this.shareQuota = '0'
      this.merchantGroupType = 0
      this.batchImportQuoteSuccessData = []
      this.resetBatchAddForm()
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 2) {
        const _row = this.filterData(this.shareGroupForm.merchantGroup, columnIndex).one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    objectSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        const _row = this.filterData(this.quitGroupForm.merchantList, columnIndex).one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    // 合并单元格
    filterData (arr, colIndex) {
      const spanOneArr = []
      const concatOne = 0
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1)
        } else {
          // class 和classify 分别表示表格数据第一列和第二列对应的参数字段，根据实际参数修改
          if (colIndex === 0) {
            if (item.class === arr[index - 1].class) {
              spanOneArr[concatOne] += 1
              spanOneArr.push(0)
            } else {
              spanOneArr.push(1)
              this.concatOne = index
            }
          } else {
            if (item.classify === arr[index - 1].classify) {
              spanOneArr[concatOne] += 1
              spanOneArr.push(0)
            } else {
              spanOneArr.push(1)
              this.concatOne = index
            }
          }
        }
      })
      return {
        one: spanOneArr
      }
    },
    /**
           * @description 上传文件
           */
    getMultiFiles (inputRef) {
      this.$refs[inputRef].click()
    },
    /**
             * @description 删除已上传文件
             */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
             * @description 选择文件
             */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    batchAddQuota () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      this.batchAddLoading = true
      const data = new FormData()
      data.append('activityId', this.info.activityId)
      data.append('rechargeType', this.BatchAddForm.rechargeType)
      data.append('multipartFile', this.multiFile)
      this.checkBatchMerchantInfo(data)
    },
    checkBatchMerchantInfo (data) {
      this.$axios.post(this.$api.batchAppend, data).then(res => {
        this.batchAddLoading = false
        if (res.respCode === '0') {
          if (res.data && res.data.failMerchants && res.data.failMerchants.length > 0) {
            this.failMerchants = res.data.failMerchants.join(', ')
            this.successNum = res.data.successCount
            this.failNum = res.data.failCount
            this.failList = res.data.failMerchants
            this.showBatchAddDialog = false
            this.showResultDialog = true
            this.searchForm.pageNo = 1
            this.getMerchantList()
          } else {
            this.$message({
              type: 'success',
              message: res.respMsg + '，成功新增' + res.data.successCount + '条',
              showClose: true
            })
            this.searchForm.pageNo = 1
            this.getMerchantList()
            this.showBatchAddDialog = false
          }
        }
      })
    },
    resetBatchAddForm () {
      this.multiFile = ''
      this.multiFileName = ''
      this.BatchAddForm.rechargeType = '1'
    },
    createQuotaGroup () {
      this.quoteGroupDialogType = 'create'
      this.showQuoteGroupDialog = true
    },
    addQuotaGroup () {
      this.quoteGroupDialogType = 'add'
      this.showQuoteGroupDialog = true
    },
    handleBatchAddQuoteGroupImport () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      const data = new FormData()
      data.append('activityId', this.info.activityId)
      data.append('multipartFile', this.multiFile)
      return data
    },
    handleAddQuoteGroup () {
      const importParams = this.handleBatchAddQuoteGroupImport()
      let apiKey = 'batchAddQuoteVerify'
      if (this.quoteGroupDialogType === 'create') {
        apiKey = 'batchCreateQuoteVerify'
      }
      this.$axios.post(this.$api[apiKey], importParams).then(res => {
        if (res.respCode === '0') {
          this.showQuoteGroupDialog = false
          const { importResult, failCount, dataList } = res.data
          if (importResult) {
            this.shareQuota = dataList[0].quota
            this.batchImportQuoteSuccessData = dataList
          } else {
            this.batchImportQuoteFailCount = failCount
            this.showQuoteGroupResultDialog = true
            this.batchImportQuoteFailData = dataList
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table{
  margin-top: 20px;
}
.timeTitle{
  margin-bottom: 20px;
}
.red {
  color: red;
}
.tips {
  color: #A3A3A4;
  padding-bottom: 20px;
}
.confirm-tips {
  color: red;
  margin-top: -10px;
}
.remark {
  /deep/ .el-input__inner {
    padding-right: 60px;
  }
}
.import-tip {
  color: #A3A3A4;
  font-size: 12px;
  margin-bottom: 20px;
}

.import {
  .el-button {
    width: 100px;
    height: 30px;
    text-align: center;
    padding: 0;
    margin: 0 12px 12px 0;
  }
  margin-right: 12px;
  margin-bottom: 8px;
}
.el-icon-question {
  display: flex;
  font-size: 35px;
  justify-content: center;
  margin-bottom: 20px;
}
.el-row{
  display:flex;
  flex-wrap: wrap;
}
.hasSelect .removeIcon{
  color:#F56C6C;
  line-height: 30px;
  cursor: pointer;
  margin-left: 10px;
}
</style>
